import React, { useEffect, useState } from 'react';
import { incomeExpenseApi } from '../../api/incomeExpenseApi';
import { printVoucherHtml } from '../../utils/voucherPrint';

export const LedgerVoucherModal: React.FC<{
  entryId: string;
  title: string;
  mode?: 'fee' | 'surplus';
  onClose: () => void;
}> = ({ entryId, title, mode, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      setFailed(false);
      setHtmlContent('');
      try {
        const html = await incomeExpenseApi.fetchLedgerVoucherHtml(entryId, mode);
        if (!cancelled) setHtmlContent(html);
      } catch {
        if (!cancelled) setFailed(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [entryId, mode]);

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-5xl max-h-[95vh] flex flex-col">
        <div className="flex items-center justify-between border-b px-4 py-3">
          <h3 className="font-semibold text-gray-900">{title}</h3>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => htmlContent && printVoucherHtml(htmlContent)}
              disabled={!htmlContent}
              className="text-sm text-cyan-600 hover:text-cyan-700 disabled:text-gray-400"
            >
              In
            </button>
            <button
              type="button"
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-xl leading-none px-2"
              aria-label="Đóng"
            >
              ×
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-auto bg-gray-100 relative" style={{ minHeight: '70vh' }}>
          {loading && !failed && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-50">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-500" />
              <span className="ml-2 text-gray-600 text-sm">Đang tải...</span>
            </div>
          )}
          {failed ? (
            <div className="flex items-center justify-center py-16 text-gray-500 text-sm">
              Không thể tải phiếu
            </div>
          ) : htmlContent ? (
            <iframe
              title={title}
              srcDoc={htmlContent}
              className="w-full border-0 bg-white"
              style={{ minHeight: '70vh', display: 'block' }}
              sandbox="allow-same-origin allow-scripts"
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default LedgerVoucherModal;
